import { cleanedEnv } from "@/env/validate";
import { MarketplaceTier } from "@mm/metx-workbench.meteomatics.com";

const MARKETPLACE_TIER_TAG_COLOR = {
  [MarketplaceTier.Core]: "green",
  [MarketplaceTier.Pro]: "turquoise",
  [MarketplaceTier.Premium]: "lila",
} as const;

export function getMarketplaceTierTagColor(tier: MarketplaceTier) {
  return MARKETPLACE_TIER_TAG_COLOR[tier];
}

export function isMarketplaceEditor(user: { username?: string } | null | undefined): boolean {
  return user?.username === cleanedEnv.REACT_APP_MARKETPLACE_PROFILE_ACCOUNT_USERNAME;
}

export function getMarketplaceAssetId(imageUrl: string): number | undefined {
  const match = imageUrl.match(/\/assets\/(\d+)(?:[/?#]|$)/);
  return match ? Number(match[1]) : undefined;
}
